import React from "react";

interface BaseRadioButtonProps {
  id: string;
  label: React.ReactNode;
  value: string;
  name: string;
  checked: boolean;
  onChange: (v: string) => void;
  className?: string;
  isDisabled?: boolean;
  labelFirst?: boolean;
}

export interface RadioButtonItem {
  id: string;
  label: React.ReactNode;
  value: string;
}

/**
 * ラジオボタンのアイテム
 * NOTE: 単体での使用を想定していないためcheckedは外から受け取る
 */
export const BaseRadioButton = ({
  id,
  label,
  value,
  name,
  checked,
  onChange,
  className = "",
  isDisabled,
  labelFirst = false,
}: BaseRadioButtonProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    onChange(e.target.value);

  return (
    <>
    { labelFirst && (
      <label
        htmlFor={id}
        title={value}
      >
        {label}
      </label>
    ) }
      <input
        className={className}
        type="radio"
        id={id}
        value={value}
        name={name}
        checked={checked}
        onChange={handleChange}
        disabled={isDisabled}
      />
    { !labelFirst && (
      <label
        htmlFor={id}
        title={value}
      >
        {label}
      </label>
    ) }
    </>
  );
};
